import cn from 'classnames';
import { TextMediaAccordionProps } from ".";
import AnimatedHeight from "../AnimatedHeight";

export type DesktopAccordionProps = {
  features: TextMediaAccordionProps['features'];
  activeFeatureIndex: number;
  onClickCallback: (index: number) => void;
}

export const DesktopAccordion = ({ features, activeFeatureIndex, onClickCallback }: DesktopAccordionProps) => (
  <div className="hidden md:flex flex-col gap-2">
    {features.map((feature, index) => (
      <div key={`desktop-feature-${feature.title?.replace(/\s/g, '-') ?? index}`} className="keen-slider__slide">
        <div
          className={cn(
            'p-3 flex flex-col gap-2 rounded-20 relative transition-colors duration-200 ease-in-out-cubic',
            {
              'bg-white': index === activeFeatureIndex,
              'border-transparent': index !== activeFeatureIndex,
            },
          )}
        >
          <div className="flex flex-col gap-1">
            <div className="flex gap-1 items-center">
              <button
                onClick={() => onClickCallback(index)}
                className={`text-left block text-20/28 font-500 tracking-tight ${index === activeFeatureIndex ? "text-gray-900" : "text-blue-900"}`}
              >
                {feature.title}
              </button>

              {feature.tag && (
                <span className="bg-citron-500 text-citron-900 block rounded-4 px-half text-10/20 h-[20px] uppercase font-mono font-800">
                  {feature.tag}
                </span>
              )}
            </div>
          </div>
          <AnimatedHeight
            isExpanded={index === activeFeatureIndex}
          >
            <div
              className="text-p2 text-gray-700"
            >
              {feature.description}
              {feature.list &&
                <ul className='list-none pt-2 text-blue-900 text-[20px] mt-3 leading-[28px] space-y-[28px]'>
                  {feature.list.map(item =>
                    <li key={item}>{item}</li>
                  )}
                </ul>
              }
            </div>
          </AnimatedHeight>
        </div>
      </div>
    ))
    }
  </div >
);
